<common-card [formGroup]="form">
  <common-card-header>
    <h3>{{'modules.order.order_type.reparation_popup.title' | translate}}</h3>
  </common-card-header>
  <common-card-body>
    <div class="container" [nbSpinner]="plateNumberLoading">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label class="label">{{'modules.order.order_type.reparation_popup.localisation' | translate}}</label>
            <input nbInput fullWidth formControlName="localisation">
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="label">{{'modules.order.order_type.reparation_popup.date' | translate}}</label>
            <input [nbDatepicker]="datepickerDate" nbInput fullWidth formControlName="date">
            <nb-datepicker #datepickerDate
                           [min]="today"
                           [format]="'DD.MM.YYYY'">
            </nb-datepicker>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="label">{{'modules.order.order_type.reparation_popup.plate_number' | translate}}</label>
            <input nbInput fullWidth formControlName="plateNumber" (change)="plateNumberChanges()">
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="label">{{'modules.order.order_type.reparation_popup.brand' | translate}}</label>
            <input nbInput fullWidth formControlName="brand">
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="label">{{'modules.order.order_type.reparation_popup.model' | translate}}</label>
            <input nbInput fullWidth formControlName="model">
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="label">{{'modules.order.order_type.reparation_popup.description' | translate}}</label>
            <textarea nbInput fullWidth formControlName="description" rows="5"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="pl-3 pr-3">
      <div class="drop_wrapper h-100">
        <div class="drop h-100 d-flex flex-column justify-content-end">
          <div class="text-center">
            <nb-icon icon="check" status="success"
                     *ngIf="file;else notUploadedIcon"
            ></nb-icon>
            <ng-template #notUploadedIcon>
              <nb-icon icon="upload"></nb-icon>
            </ng-template>
          </div>
          <div class="text-center">
            <b>
              {{'modules.order.order_type.reparation_popup.load_image' | translate}}
            </b>
          </div>
          <div class="caption text-center mb-3">
            {{'modules.mission.document_upload.form.drag_drop_file_here_or_browse_files' | translate}}
          </div>
        </div>
        <input type="file"
               [accept]="FILE_TYPES"
               [multiple]="true"
               (change)="valetUploadMultipleDocuments($event)"
        >
      </div>
    </div>
    <div class="col-12 mt-4">
      <div class="row">
        <div class="col-4"
             formArrayName="pictures"
             *ngFor="let file of documentsFormArray(); let i = index">
          <div class="form-group" [formGroupName]="i">
            <input nbInput type="text"
                   fullWidth
                   required
                   readonly
                   formControlName="name">
            <div class="d-flex justify-content-end">
              <button nbButton type="button"
                      size="tiny"
                      status="danger"
                      ghost
                      (click)="removeItemFromDocumentsArray(i)">
                {{'modules.quality.quality_valet.form.remove' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </common-card-body>
  <common-card-footer>
    <div class="row">
      <div class="col-12 text-right">
        <button nbButton status="primary" (click)="submit()">
          {{'global.button.submit' | translate}}
        </button>
      </div>
    </div>
  </common-card-footer>
</common-card>
